import { createSlice } from '@reduxjs/toolkit';

const integrationsSlice = createSlice({
  name: 'integrations',
  initialState: {
    list: [],
    activeIntegration: null,
    projects: [],
    assignees: [],
    issueTypes: [],
    priorities: [],
    isLoading: false,
  },
  reducers: {
    setIntegrations(state, action) {
      state.list = action.payload;
      state.isLoading = false;
    },
    resetIntegrations(state) {
      state.list = [];
      state.activeIntegration = null;
      state.projects = [];
      state.assignees = [];
      state.issueTypes = [];
      state.priorities = [];
      state.isLoading = false;
    },
  },
});

export const { setIntegrations, resetIntegrations } = integrationsSlice.actions;
export default integrationsSlice.reducer;
